import { MainButton } from 'global-styles/MainButton';
import { GoToIcon } from 'assets/icons';
import { useContactModal } from 'hooks/useContactModal';
import { useRouter } from 'next/router';
import styled from 'styled-components';

const SR1SR2Buttons = () => {
  const { locale } = useRouter();
  const { handleOpenContactModal } = useContactModal();

  return (
    <>
      <ProductTemplateMainButton
        buttonType="default"
        text={locale === 'en' ? 'Try For Free' : '체험 해보기'}
        icon={<GoToIcon />}
        iconPosition="right"
        tag="a"
        href="https://www.kokoon.cloud"
        target="_blank"
      />
      <ProductTemplateMainButton
        onClick={handleOpenContactModal}
        buttonType="default"
        text={locale === 'en' ? 'Contact us' : '제품 문의하기'}
      />
    </>
  );
};

const SR3Buttons = () => {
  const { locale } = useRouter();
  const { handleOpenContactModal } = useContactModal();
  return (
    <>
      <ProductTemplateMainButton
        onClick={handleOpenContactModal}
        buttonType="default"
        text={locale === 'en' ? 'Contact us' : '제품 문의하기'}
      />
    </>
  );
};

export const ProductTemplateButtons = {
  sr1sr2: <SR1SR2Buttons />,
  sr3: <SR3Buttons />,
  pqo: <SR3Buttons />,
  av1: <SR3Buttons />,
  avif: <SR3Buttons />,
  vmaf: <SR3Buttons />,
};

const ProductTemplateMainButton = styled(MainButton)`
  width: 156px;
  height: 48px;
`;
